/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { MonthlyCoveragePlanDto } from './monthlyCoveragePlanDto.schema';

export const CreateMonthlyCoveragePlan = zod.object({
  "payload": zod.lazy(() => MonthlyCoveragePlanDto).optional()
});

export type CreateMonthlyCoveragePlan = zod.input<typeof CreateMonthlyCoveragePlan>;
export type CreateMonthlyCoveragePlanOutput = zod.output<typeof CreateMonthlyCoveragePlan>;
